export const DropdownOutsideClick = (e, ref, func) => {
	if (ref) {
		if (!ref.contains(e.target)) {
			func(false)
		}
	}
}
